// スライダー設定
$(function() {
  const MCSB_VIEWPORT = window.matchMedia("(max-width:1258px)");
  mCSBActivate();

  // mCSB起動
  function mCSBActivate() {
    if(!$('#make_mscb')) return;
    if(MCSB_VIEWPORT.matches) {
      $('#make_mscb').mCustomScrollbar({
        axis: 'x'
      });
    } else {
      $('#make_mscb').mCustomScrollbar('destroy');
    }
  }

  // リサイズ時実行
  // -----------------------------------------------------
  window.addEventListener('resize', function() {
    //メディアクエリ連動
    mCSBActivate();
  });

  // スライダー作成
  // -----------------------------------------------------
  let $slider = $('#slider');
  $slider.slick({
    infinite: true,
    arrows: true,
    autoplay: false,
    dots: true,
    dotsClass: 'thumbnails',
    customPaging: function(slick,index) {
      // スライダーのインデックス番号に対応した画像のsrcを取得
      var targetImage = slick.$slides.eq(index).find('img').attr('src');
      // slick-dotsに上記で取得した画像を設定
      return '<img src=" ' + targetImage + ' "/>';
    }
  });

  // モーダル系
  // -----------------------------------------------------
  if(document.getElementById('map_modal')) {
    let modal = document.getElementById('map_modal');
    // モーダルを開く
    let open = document.getElementById('modal_on');
    open.addEventListener('click', function() {
      $(modal).fadeIn(500);
    })
      // クローズボタンクリックで閉じる
      // 画像外をクリックしても閉じる
    modal.addEventListener('click', function(e) {
      if(!e.target.dataset.close) {
        $(modal).fadeOut(500);
      }
    });
  }

  // SP時追従メニュー
  // ------------------------------------------------------
  let stickyBtn = document.querySelector('.search_detail .btn02');
  window.addEventListener('scroll', function() {
    // トリガーまでの距離を取得: 基準は画面上端
    let tgrOffset = document.querySelector('.search_detail .ttl01').getBoundingClientRect().top - 20;
    // フッターまでの距離を取得: 基準は画面下端
    let footerOffset = document.querySelector('.related_link_blk').getBoundingClientRect().top - window.innerHeight;
    // トリガー位置を超える かつ ボタンが非表示なら
    if (tgrOffset < 0) {
      // 既に表示されていれば何もしない
      if (!stickyBtn.classList.contains('is_active')) {
        // ボタン表示
        stickyBtn.classList.add('is_active');
      }
    } else {
      // ボタン非表示
      stickyBtn.classList.remove('is_active');
    }
    // フッターにさしかかると非表示 
    if (footerOffset < 0) {
      stickyBtn.classList.add('is_hide');
    } else {
      stickyBtn.classList.remove('is_hide');
    }
  });
});